// extracted by mini-css-extract-plugin
module.exports = {"button":"RecentlyPlayedButton-button_71f5eee4","opaque":"RecentlyPlayedButton-opaque_21bdb1a4","secondaryText":"RecentlyPlayedButton-secondaryText_0a8a36cc"};